import React from 'react';
import { Box, Typography } from '@mui/material';
import formatFieldValue from './formatFieldValue';

// One label/value pair in a record's detail view.
const FieldRow = ({ label, value, type, fieldId }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '160px 1fr' }, columnGap: 2, py: 0.75 }}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 500, wordBreak: 'break-word' }}>
      {formatFieldValue(value, type, fieldId)}
    </Typography>
  </Box>
);

export default FieldRow;
